/* file: assets/j_spend-gifts.js */

/******* SPEND GIFTS (CHOICE ONLY) — ES5 SAFE + SINGLETON FETCH + DEBOUNCE + A11Y + DIAG *******/

(function () {
  /* ===== 0) LOG TOGGLES ===== */
  var JSG_DEBUG = false;  // set by snippet config.debug
  var JSG_TRACE = false;  // set true only when diagnosing

  console.log("Cart Spend Gifts Active");

  function jsgLog(level) {
    if (!JSG_DEBUG) return;
    var args = Array.prototype.slice.call(arguments, 1);
    (console[level] || console.log).apply(console, ['[JSG]'].concat(args));
  }
  function jsgTrace() {
    if (!JSG_TRACE) return;
    var args = Array.prototype.slice.call(arguments);
    console.log.apply(console, ['[JSG:TRACE]'].concat(args));
  }

  /* ===== 1) SINGLETON CART FETCH + DEBOUNCE ===== */
  var __jsgRefreshTimer = null;
  var __jsgCartFetchInFlight = null;
  var __jsgIsRunning = false;
  var __jsgLastRunAt = 0;

  function jsgDebouncedRefresh(delay) {
    if (typeof delay !== 'number') delay = 120;
    if (__jsgRefreshTimer) cancelAnimationFrame(__jsgRefreshTimer);
    __jsgRefreshTimer = requestAnimationFrame(function () {
      setTimeout(function () { jsgRefresh(); }, delay);
    });
  }

  function jsgGetCart() {
    if (__jsgCartFetchInFlight) return __jsgCartFetchInFlight;
    __jsgCartFetchInFlight = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function (err) { jsgLog('error', 'GET /cart.js failed', err); throw err; })
      .finally(function () { __jsgCartFetchInFlight = null; });
    return __jsgCartFetchInFlight;
  }

  /* ===== 2) DOM + CONFIG PARSE ===== */
  var jsgRefs = {
    container: null,
    unlock: null,
    msg: null,
    btn: null,
    cfg: null
  };

  function jsgParseConfigFrom(el) {
    if (!el || !el.dataset || !el.dataset.config) return null;
    try { return JSON.parse(el.dataset.config); }
    catch (e) { return null; }
  }

  function jsgInitRefs(force) {
    if (jsgRefs.container && force !== true) {
      try { if (document.body.contains(jsgRefs.container)) return; } catch (_) {}
    }

    jsgRefs.container = document.querySelector('.j_sg-container') || null;
    jsgRefs.cfg = jsgParseConfigFrom(jsgRefs.container);

    jsgRefs.unlock = jsgRefs.container ? jsgRefs.container.querySelector('#j_sg-unlock') : null;
    jsgRefs.msg = jsgRefs.container ? jsgRefs.container.querySelector('.j_sg-msg') : null;
    jsgRefs.btn = jsgRefs.container ? jsgRefs.container.querySelector('.j_sg-choose') : null;

    // config-driven logs
    if (jsgRefs.cfg && jsgRefs.cfg.debug) {
      JSG_DEBUG = true;
      JSG_TRACE = true;
    }

    jsgTrace('initRefs', {
      hasContainer: !!jsgRefs.container,
      hasCfg: !!jsgRefs.cfg,
      hasUnlock: !!jsgRefs.unlock,
      hasMsg: !!jsgRefs.msg,
      hasBtn: !!jsgRefs.btn
    });
  }

  function jsgAccessAllowed(access, customerLogged) {
    var a = String(access || 'everyone');
    if (a === 'everyone') return true;
    if (a === 'logged') return !!customerLogged;
    if (a === 'general') return !customerLogged;
    return true;
  }

  /* ===== 3) A11Y SHOW/HIDE ===== */
  function jsgSetInert(el, value) {
    if (!el) return;
    try { el.inert = !!value; } catch (e) {}
    if (value) el.setAttribute('inert', '');
    else el.removeAttribute('inert');
  }

  function jsgHideSection(el) {
    if (!el) return;
    jsgSetInert(el, true);
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
  }

  function jsgShowSection(el) {
    if (!el) return;
    jsgSetInert(el, false);
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');
  }

  /* ===== 4) SPEND SUBTOTAL (EXCLUDING PROMO/GIFT LINES) ===== */
  function jsgIsSpendExcludedLine(item) {
    if (!item) return false;
    var p = item.properties || {};

    // Rewards module flags
    if (p._reward1 === 1 || p._reward1 === '1' || p._reward1 === true || p._reward1 === 'true') return true;
    if (p._reward2 === 1 || p._reward2 === '1' || p._reward2 === true || p._reward2 === 'true') return true;
    if (p._reward3 === 1 || p._reward3 === '1' || p._reward3 === true || p._reward3 === 'true') return true;

    // Legacy reward flags
    if (p._mystery === 1 || p._mystery === '1' || p._mystery === true || p._mystery === 'true') return true;
    if (p.mystery === 1 || p.mystery === '1' || p.mystery === true || p.mystery === 'true') return true;
    if (p._premium === 1 || p._premium === '1' || p._premium === true || p._premium === 'true') return true;

    // Cart Gifts (buy X get gift) flags
    if (p._jcg_gift === 1 || p._jcg_gift === '1' || p._jcg_gift === true || p._jcg_gift === 'true') return true;

    return false;
  }

  function jsgGetSpendSubtotal(cart) {
    var sum = 0;
    (cart.items || []).forEach(function (i) {
      if (jsgIsSpendExcludedLine(i)) return;
      var lp = (i.line_price != null) ? Number(i.line_price) : (Number(i.price || 0) * Number(i.quantity || 1));
      sum += lp;
    });
    return sum;
  }

  /* ===== 4b) COLLECTION MEMBERSHIP (CACHE) ===== */
    var __jsgCollectionCache = {}; // handle -> { handlesMap: {handle:true}, loaded:true }

    function jsgGetCollectionHandleMap(handle) {
      var h = String(handle || '').trim().toLowerCase();
      if (!h) return Promise.resolve({ loaded: true, handlesMap: {} });

      if (__jsgCollectionCache[h] && __jsgCollectionCache[h].loaded) {
        return Promise.resolve(__jsgCollectionCache[h]);
      }

      __jsgCollectionCache[h] = __jsgCollectionCache[h] || { loaded: false, handlesMap: {} };

      // Shopify collection JSON endpoint
      var url = '/collections/' + encodeURIComponent(h) + '/products.json?limit=250';

      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var map = {};
          var prods = data && data.products ? data.products : [];
          for (var i = 0; i < prods.length; i++) {
            if (prods[i] && prods[i].handle) map[String(prods[i].handle).toLowerCase()] = true;
          }
          __jsgCollectionCache[h] = { loaded: true, handlesMap: map };
          jsgTrace('collection loaded', h, 'count=', Object.keys(map).length);
          return __jsgCollectionCache[h];
        })
        .catch(function (e) {
          // Fail safe: if we can't load, don't block rendering (but we can't do "remaining" correctly)
          jsgLog('warn', 'collection load failed', h, e);
          __jsgCollectionCache[h] = { loaded: true, handlesMap: {} };
          return __jsgCollectionCache[h];
        });
    }

    function jsgIsClaimedGiftLine(item, handlesMap) {
      if (!item) return false;

      var h = String(item.handle || '').toLowerCase();
      var p = item.properties || {};

      // Must belong to the gift collection
      if (!handlesMap[h]) return false;

      // Consider claimed if:
      // 1) price is zero (auto discount applied)
      // OR
      // 2) explicitly marked as spend gift
      var lp = (item.final_line_price != null)
        ? Number(item.final_line_price)
        : Number(item.line_price);

      if (lp === 0) return true;
      if (p._spend_gift === '1' || p._spend_gift === 1 || p._spend_gift === true) return true;

      return false;
    }


  function jsgCountClaimedQtyFromCollection(cart, handlesMap) {
    var count = 0;

    (cart.items || []).forEach(function (i) {
      if (jsgIsClaimedGiftLine(i, handlesMap)) {
        count += Number(i.quantity || 0);
      }
    });

    return count;
  }



  /* ===== 5) TIER RESOLUTION ===== */
  function jsgClamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function jsgResolveEligibleQty(totalCents, tiers, maxQty) {
    if (!Array.isArray(tiers) || !tiers.length) return 0;

    // Normalize + sort ascending by amount
    var list = tiers
      .map(function (t) {
        return {
          amount: Number(t && t.amount || 0),
          qty: Number(t && t.qty || 0)
        };
      })
      .filter(function (t) { return t.amount > 0 && t.qty > 0; })
      .sort(function (a, b) { return a.amount - b.amount; });

    if (!list.length) return 0;

    var bestQty = 0;
    for (var i = 0; i < list.length; i++) {
      if (totalCents >= list[i].amount) bestQty = list[i].qty;
    }

    bestQty = jsgClamp(bestQty, 0, Number(maxQty || 5) || 5);
    return bestQty;
  }

  function jsgPlural(n, one, many) {
    return (Number(n) === 1) ? one : many;
  }

  function jsgBuildMessage(eligibleQty, remainingQty, cfg) {
    var tpl = (cfg && cfg.message_tpl) ? String(cfg.message_tpl) : 'You got %qty% free gifts from %product%.';
    var product = (cfg && cfg.product_name) ? String(cfg.product_name)
      : ((cfg && cfg.collection_title) ? String(cfg.collection_title) : 'your gift collection');

    return jsgApplyTemplate(tpl, {
      qty: eligibleQty,
      remaining: remainingQty,
      product: product
    });
  }


  /* ===== 6) RENDER ===== */

  function jsgApplyTemplate(tpl, data) {
    tpl = String(tpl || '');
    data = data || {};
    return tpl
      .replace(/%qty%/gi, String(data.qty != null ? data.qty : ''))
      .replace(/%remaining%/gi, String(data.remaining != null ? data.remaining : ''))
      .replace(/%product%/gi, String(data.product != null ? data.product : ''));
  }

  function jsgRenderHidden() {
    if (!jsgRefs.unlock) return;
    if (jsgRefs.msg) jsgRefs.msg.innerHTML = '';
    jsgHideSection(jsgRefs.unlock);
  }

  function jsgRenderVisible(qty) {
    if (!jsgRefs.unlock) return;

    if (jsgRefs.msg) {
      var cfg = jsgRefs.cfg || {};
      var title = String(cfg.title);

      var tpl = String(cfg.message_tpl || 'You got %qty% free gifts from %product%.');
      var productName = String(cfg.product_name || cfg.collection_title || cfg.collection_handle || 'your gift collection');

      // optional remaining logic (once we add remaining later)
      var remaining = Number(cfg.remaining != null ? cfg.remaining : qty);

      var msg = jsgApplyTemplate(tpl, {
        qty: qty,
        remaining: remaining,
        product: productName
      });

      jsgRefs.msg.innerHTML = '<strong>' + msg + '</strong> ';
    }


    // Ensure button href is correct from config (in case section HTML was swapped)
    if (jsgRefs.btn && jsgRefs.cfg && jsgRefs.cfg.collection_url) {
      jsgRefs.btn.href = String(jsgRefs.cfg.collection_url);
      if (jsgRefs.cfg.button_text) jsgRefs.btn.textContent = String(jsgRefs.cfg.button_text);
      jsgRefs.btn.setAttribute('aria-label', jsgRefs.btn.textContent || 'Choose gift');
    }

    jsgShowSection(jsgRefs.unlock);
  }

  /* ===== 7) MAIN REFRESH ===== */
  function jsgRefresh(force) {
    var now = Date.now();
    if (!force && now - __jsgLastRunAt < 120) return;
    __jsgLastRunAt = now;

    if (__jsgIsRunning) { jsgTrace('refresh skipped (in flight)'); return; }
    __jsgIsRunning = true;

    jsgInitRefs(true);

    if (!jsgRefs.container || !jsgRefs.cfg || !jsgRefs.unlock) {
      __jsgIsRunning = false;
      return;
    }

    var cfg = jsgRefs.cfg;
    var allowed = jsgAccessAllowed(cfg.access, cfg.customer_logged);

    if (!allowed) {
      jsgTrace('access blocked', cfg.access, cfg.customer_logged);
      jsgRenderHidden();
      __jsgIsRunning = false;
      return;
    }

    // Hard safety: must have a collection url + tiers
    if (!cfg.collection_url || !Array.isArray(cfg.tiers)) {
      jsgTrace('missing config fields', cfg);
      jsgRenderHidden();
      __jsgIsRunning = false;
      return;
    }

    jsgGetCart().then(function (cart) {
      var total = jsgGetSpendSubtotal(cart);
      var eligibleQty = jsgResolveEligibleQty(total, cfg.tiers, cfg.max_qty);

      if (eligibleQty <= 0) {
        jsgTrace('not qualified', { total: total, eligibleQty: eligibleQty });
        jsgRenderHidden();
        return;
      }

      // Load collection membership once, then count how many free gifts already in cart
      return jsgGetCollectionHandleMap(cfg.collection_handle).then(function (col) {
        var alreadyFreeQty = jsgCountClaimedQtyFromCollection(cart, col.handlesMap);
        var remaining = Math.max(0, eligibleQty - alreadyFreeQty);

        jsgTrace('refresh', {
          item_count: cart.item_count,
          subtotal_excl_rewards: total,
          eligible_qty: eligibleQty,
          already_free_qty_from_collection: alreadyFreeQty,
          remaining: remaining
        });

        // Hide when fully claimed
        if (remaining <= 0) {
          jsgTrace('fully claimed → hidden');
          jsgRenderHidden();
          return;
        }

        // Store for renderer (optional)
        cfg.remaining = remaining;

        // Render with remaining support
        if (jsgRefs.msg) {
          jsgRefs.msg.innerHTML = '<strong>' + jsgBuildMessage(eligibleQty, remaining, cfg) + '</strong>';
        }

        jsgRenderVisible(eligibleQty);
      });
    }).catch(function (e) {
      jsgLog('error', 'jsgRefresh failed', e);
    }).finally(function () {
      __jsgIsRunning = false;
    });
  }

  /* ===== 8) EVENT LISTENERS ===== */
  var __jsgListenersAttached = false;

  function jsgAttachListeners() {
    if (__jsgListenersAttached) return;
    __jsgListenersAttached = true;

    var names = [
      'cart:updated', 'cart:change', 'cart:refresh',
      't4s:cart:updated', 't4s:cart:change',
      'ajaxCart:updated', 'ajaxProduct:added',
      'added.ajaxProduct', 'removed.ajaxProduct'
    ];

    names.forEach(function (n) {
      document.addEventListener(n, function () {
        jsgDebouncedRefresh(120);
      }, { passive: true });
    });
  }

  /* ===== 8b) GLOBAL CART EVENT LOGGER (DIAG) ===== */
var __jsgCartEventLoggerAttached = false;

function jsgAttachCartEventLogger() {
  if (__jsgCartEventLoggerAttached) return;
  __jsgCartEventLoggerAttached = true;

  var names = [
    'cart:updated', 'cart:change', 'cart:refresh',
    't4s:cart:updated', 't4s:cart:change',
    'ajaxCart:updated', 'ajaxProduct:added',
    'added.ajaxProduct', 'removed.ajaxProduct',
    'jcg:gifts' // from your j_cart-gifts.js emitter
  ];

  function safeDetail(d) {
    // avoid circular crash in console
    try { return d == null ? null : JSON.parse(JSON.stringify(d)); }
    catch (_) { return d; }
  }

  names.forEach(function (n) {
    document.addEventListener(n, function (e) {
      console.log('[CART EVENT]', n, {
        time: new Date().toISOString(),
        detail: safeDetail(e && e.detail)
      });
    }, { passive: true });
  });

  // Optional: log fetches triggered by this script
  console.log('[JSG] Cart event logger attached:', names);
}


  /* ===== 9) DIAGNOSTIC INSPECTOR ===== */
  window.__jsgDiag = function () {
    jsgInitRefs(true);
    var info = {
      hasContainer: !!jsgRefs.container,
      hasCfg: !!jsgRefs.cfg,
      cfg: jsgRefs.cfg,
      hasUnlock: !!jsgRefs.unlock,
      hasMsg: !!jsgRefs.msg,
      hasBtn: !!jsgRefs.btn
    };
    console.log('[JSG:DIAG]', info);
    return info;
  };

  /* ===== 10) BOOT ===== */
  document.addEventListener('DOMContentLoaded', function () {
    jsgInitRefs(true);
    jsgAttachListeners();
    jsgAttachCartEventLogger();
    jsgRefresh(true);
  });

})();
